(function (ws, $) {
    'use strict';

    ws.views.quoteTableTooltipAvailablity = Backbone.View.extend({

        className: 'comp-table-tooltip-availability',

        /**
         * Abort DOM change if tooltip was aborted
         */
        isAbort: false,

        /**
         * Initialize
         */
        initialize: function () {
            // define templates
            this.templates = {
                tooltip: _.template($('#comp-table-tooltip-availability').html()),
                loader: _.template($('#comp-table-tooltip-availability-loader').html()),
                error: _.template($('#comp-table-tooltip-availability-error').html())
            };
        },

        /**i
         * Render Tooltip
         */
        render: function () {
            this.$el.html(this.templates.loader);
            this.fetch();

            return this;
        },

        /**
         * Update Tooltip
         */
        update: function () {
            if (!this.isAbort) {
                this.$el.html(this.templates.tooltip(this.model.toJSON()));
            }
        },

        /**
         * API Error
         */
        error: function () {
            if (!this.isAbort) {
                this.$el.html(this.templates.error);
            }
        },

        /**
         * Fetch Data
         */
        fetch: function () {
            this.model.fetch()
                .done(this.update.bind(this))
                .fail(this.error.bind(this));
        },

        /**
         * Abort Fetch
         */
        abort: function () {
            this.isAbort = true;
        }

    });
})(westcon, jQuery);
